

import { Component, Vue } from "vue-property-decorator";
import { MstMemberVO, SlvMemberJoinVO } from '@/views/biz/join/vo/join.vo'
import axios from 'axios';
import CommonUtils from "@/common-utils";

@Component
export default class MemberInfoConfirm extends Vue {
  
  member: MstMemberVO = {} as MstMemberVO;
  slvMember: SlvMemberJoinVO = {} as SlvMemberJoinVO;
  isLoaded = false;

  // 비밀번호 검증
  validatiePassword() {
    if(!this.member.memPwd) {
      // 비밀번호를 입력해주세요.
      return alert(this.$t('member-info.a0008'));
    }

    axios.post('/mypage/profile/validation', this.member)
    .then(r=> {
      if(r.data) {
        // 수정화면으로 이동
        this.$router.push({name: 'MemberInfo'});
      } else {
        // 비밀번호가 일치하지 않습니다.
        return alert(this.$t('member-info.a0005'));
      }
    })
  }

  // sns 애플 인증
  confirmAppleLogin(provider: string): void {
    const userAgent = navigator.userAgent.toLowerCase();
    if(window['ReactNativeWebView'] && userAgent.indexOf('iphone') > -1){
      window["webViewBridge"].send("appleLogin", {}, this.callbackSnsConfirm);
    }else{
      const url = process.env.VUE_APP_BASE_URL_API + `/oauth2/authorization/${provider}`;
      location.href = url;
    }
  }

  //앱버전 - 애플로그인
  callbackSnsConfirm(result: any): void{
    axios.post('/mypage/profile/validation2', {appleUser: result})
    .then(r=> {
      if(r.data) {
        // 수정화면으로 이동
        this.$router.push({name: 'MemberInfo'});
      } else {
        // 토큰 인증이 실패됐습니다.
        return alert(this.$t('member-info.a0025'));
      }
    });    
  }

  created(): void {
    // 이미 검증하고 왔다면
    if(this.$route.query.success || this.$route.query.message) {
      if(this.$route.query.message) {
        alert(this.$t(this.$route.query.message as string));
      } else {
        this.$router.push({name: 'MemberInfo'});
      }
    }

    // 인증 전 회원정보 세션에 저장(signWithApple 웹 전용)
    if(CommonUtils.isApp() == false) {
      axios.post('/mypage/member-info/confirm');
    }
      

    axios.get('/member')
    .then(r=>{
      this.slvMember.joinType = r.data.joinType;
      if(r.data.validatPreexistencePassword == 'N' && this.slvMember.joinType !='14') {
        // 비밀번호가 설정되지 않아 비밀번호 변경 페이지로 이동합니다.
        alert(this.$t('mypage.a0007'));
        this.$router.push({name: 'ChangePassword'})
      } else {
        this.isLoaded = true;
      }
    })
  }
}
